import { Flex, HStack, Skeleton } from '@react/chakra';

import type { JSX } from 'react';

export function TopicListSkeleton(): JSX.Element {
  return (
    <HStack gap={2} flexWrap='wrap'>
      {Array.from({
        length: 4,
      }).map((_, index) => {
        return (
          <Flex
            key={index}
            pos='relative'
            transitionDuration='.15s'
            transitionTimingFunction='cubic-bezier(.4, 0, .2,1)'
            transitionProperty='color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter'
          >
            <Skeleton
              borderRadius='9999px'
              w={{
                base: 32,
                md: 36,
              }}
              h={{
                base: '46px',
                md: '62px',
              }}
            />
          </Flex>
        );
      })}
    </HStack>
  );
}
